import { Inject, Injectable } from '@angular/core';
import { SectionPermission } from 'app/shared/models/section-permission.model';
import { MediaService } from 'app/shared/services/media.service';
import { SectionService } from 'app/shared/services/section.service';
import { EventService } from 'app/shared/services/event.service';

@Injectable()
/*@Component({
  selector: 'app-generic-base',
  templateUrl: './generic-base.component.html',
  styleUrls: ['./generic-base.component.scss']
})*/

export abstract class GenericBaseComponent {

  sectionPermission: SectionPermission;
  protected eventService: EventService;

  hasDesktopView: boolean;
  private mediaService = new MediaService('(min-width: 768px)');

  constructor(protected sectionService?: SectionService, @Inject('sectionName') protected sectionName?: string) {
  }

  initialize() {
    this.mediaService.match$.subscribe(value => this.hasDesktopView = value);

    if (this.sectionPermission == null) {
      this.sectionPermission = new SectionPermission();
    }

    this.eventService = new EventService();

    if (this.sectionService && this.sectionName) {
      this.sectionService.getObject<SectionPermission>('/section/permissions/' + this.sectionName, null, (object) => {
        this.sectionPermission = object;
        this.eventService.firePermissionsLoadedEvent();
      });
    }
  }

  hasPermission(roleName: string) {
    return (this.sectionPermission.Roles.find(r => r.Name == roleName) != undefined);
  }
}
